module.exports = __webpack_public_path__ + "static/img/new-01.f251482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-01.jpg
// module id = cOng
// module chunks = 0